// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__WHQyL","timerIcon":"header_timerIcon__3Pbl-","title":"header_title__ljclL"};